import React from 'react'
import Link from 'gatsby-link'
import Publist from '../layouts/publications.js'
import Navigoat from '../layouts/navigoat.js'
import Overlaid from '../layouts/3d_overlay.js'


export default class IndexPage extends React.Component {
  state = {
    'overlay':false
  }

  handleClick = () => {
    this.setState({'overlay':true})
  }

  removeSpice = () => {
    this.setState({'overlay':false})
  }

  render() {
    const overlay = this.state.overlay;
    return (
    <div>
      <Navigoat active_tab = 'about' />
      {overlay ? (<Overlaid spicePass={this.removeSpice.bind(this)} />) : null}
      <div className = "container" id="top-padded">
      		<div className = "row">
      			<div className = "col-lg-9">
      				<div className = "panel panel-default">
      					<img className = "portrait" src = "imgs/sm_portrait.png"></img>
      					<div className = "panel-body">
      						<div className = "page-header" id="fit-my-portrait">
      						<p>I am in my final year as a <strong>PhD Candidate</strong> from <a href = "http://www.cc.gatech.edu/" ><strong className = "dark-link"> Georgia Institute of Technology</strong></a> in the Computational Science and Engineering department. I am an active member of <a href = "http://poloclub.gatech.edu/"><strong className = "polo-orange"> Polo </strong> <strong className = "dark-link">Club of Data Science</strong></a>.
                  I am on the job market!
                  <strong> Take a look at my current <a href="data/robert_pienta_cv.pdf">CV</a>.
                  </strong></p>
                  I completed my undergraduate degree in 2011 at Rose-Hulman Institute of Technology in computer science and mathematics. I'm an avid biker.
      						</div>

                  <h3> Summary & Interests </h3>

                  <div className="lg-light-osans left-half">My research blends methods, techniques, and principles from visual analytics and data mining to create new, interactive, scalable tools that empower analysts when exploring, querying, and analyzing large million-edge networks. My work enables analysts to: quickly explore massive graphs from a local perspective (<Link to="/pr_facets">FACETS</Link>), visually formulate expressive graph queries with graph autocomplete (<Link to="/pr_visage/">VISAGE</Link>), and summarize large numbers of graph query results (<Link to="/pr_vigor/">VIGOR</Link>).
                  </div>

                  <h3> Education</h3>
                  <div className = "left">Fall 2017</div>
                    <div className = "right"><strong>Georgia Institute of Technology</strong>
                      <span className="space"> </span>
                      <em> Atlanta, GA </em>
                      <br/>
                      Ph.D. in Computational Science and Engineering
                      <br/>
                      <a href="data/17-dissertation-pientars.pdf">
                        <em>
                          Adaptive Visual Network Analytics:  Algorithms, Interfaces, and Systems for Exploration and Querying.
                        </em>
                      </a>
                      <br/>
                       Adviser: Polo Chau
                      <br/>
                      Committee: Shamkant Navathe, James Abello, Jilles Vreeken, Hanghang Tong, Bistra Dilkina, Alex Endert
                      <span className="space"> </span>
                    </div>

                    <div className = "left">Spring 2014</div>
                    <div className = "right"><strong>Georgia Institute of Technology</strong>
                      <span className="space"> </span>
                      <em> Atlanta, GA </em>
                      <br/>
                      Masters in Computational Science and Engineering
                    </div>

                    <div className = "left">2007-2011</div>
                    <div className = "right"><strong>Rose-Hulman Institute of Technology</strong>
                      <span className="space"> </span>
                      <em> Terre Haute, IN </em>
                      <br/>
                      Double major in Computer Science and Mathematics.
                      <span className="space"> </span>
                    </div>

                  <h3> Honors & Awards </h3>
                  <div className = "left">2017</div>
                  <div className = "right"><strong>Best Demo</strong>, Honorable Mention at ACM SIGMOD/PODS Conference</div>
                  <div className = "left">2015-2017</div>
                  <div className = "right"><strong>FLAMEL Fellowship</strong>, a doctoral training program designed to innovate in computing, mathematics, material science, and manufacturing to accelerate the creation of new high performance materials.</div>
                  <div className = "left">2011-2015</div>
                  <div className = "right"><strong>Presidential Fellowship</strong>, offered annually to a select number of highly qualified U.S. citizens or permanent residents, who bring exemplary levels of scholarship and innovation.</div>
                  <div className = "left">Summer 2010</div>
                  <div className = "right"><strong>Best Poster</strong>, Computational Science and Cybersecurity best paper award at the University of Houston</div>
                  <div className = "left">2007-2011</div>
                  <div className = "right"><strong>Deans List</strong>, maintain a GPA above 3.5 at Rose-Hulman Institute of Technology.</div>

      						<h3> Work Experience</h3>
                      <div className = "left-no-pad">Summer 2016</div>
                      <div className = "right"><strong>Pindrop</strong>
                        <span className="space"> </span>
                        <em> Atlanta, GA </em>
                        <br/>
                         Ph.D. Research Intern
                        <br/>
                        <span className="light-text">
                        Created a visual analytics system to track the changes in telephone scams. Developed techniques to collect, measure, and chart the landscape of fraud in the telephony channel.
                        <br/>
                        <em>Principal Investigator: Terry Nelms</em>
                        </span>


                      </div>

                      <div className = "left">Summer 2015</div>
                      <div className = "right"><strong>Pindrop</strong>
                        <span className="space"> </span>
                        <em> Atlanta, GA </em>
                        <br/>
                         Ph.D. Research Intern
                        <br/>
                        <span className="light-text">
                        Leveraged large heterogeneous data to supplement machine learning methods which improved the quality of fraud detection and prediction. Prototyped a visual-analytics system to flag suspicious call behavior as it occurs.
                        <br/>
                        <em>Principal Investigator: David Dewey</em>
                        </span>
                      </div>

      								<div className = "left">Summer 2014</div>
      								<div className = "right"><strong>Google</strong>
      									<span className="space"> </span>
      									<em> Mountain View, CA </em>
      									<br/>
      									  Ph.D. Software-Engineer Intern
                          <span className="space"> </span>
                        <br/>
                        <span className="light-text">
                        Improving Ad-Quality Filtering - Designed and implemented a series of entropy-based filters to improve the quality of matched ads.
                        <br/>
                        <em>Host: Esteban Real</em>
                        </span>

      								</div>

      								<div className = "left">Fall 2013</div>
      								<div className = "right"><strong>LogicBlox</strong>
      									<span className="space"> </span>
      									<em> Atlanta, GA </em>
      									<br/>
      									 Ph.D. Intern
                        <br/>
                        <span className="light-text">
                        Tested and compared high performance tuple-matching queries on a custom database management system against industry competitors.
                        <br/>
                        <em>Mentor: Molham Aref</em>
                        </span>

      								</div>

      								<div className = "left">Summer 2013</div>
      								<div className = "right"><strong>Google</strong>,
      									<span className="space"> </span>
      									<em> Mountain View, CA </em>
      									<br/>
      									Ph.D. Software-Engineer Intern
                        <br/>
                        <span className="light-text">
                        Designed methods and visualizations to help engineers interactively compare and contrast predictive-model performance.
                        <br/>
                        <em>Host: Yanli Cai</em>
                        </span>

      								</div>

      								<div className = "left">Summer 2010</div>

      								<div className = "right"><strong>University of Houston</strong>
                        <br/>
                        <span className="light-text">
                        Researched in the <a href = "http://www.cpl.uh.edu/"> Computational Physiology Lab</a> performing thermal facial expression recognition research.
                        </span>
                      </div>

      								<div className = "left">Summer 2009</div>
      								<div className = "right"><strong>University of Iowa</strong>
                      <br/>
                      <span className="light-text">
                        Worked as a software engineer to develop tools for drawing and testing students on organic chemistry.
                      </span>
                      </div>


      							<h3> Publications </h3>
                    <Publist/>


                    <h3>Invited Talks & Presentations</h3>
                    <div className = "right-tight bold space-above">
                    <a href="data/17-dissertation-pientars.pdf">
                        Adaptive Visual Network Analytics:  Algorithms, Interfaces, and Systems for Exploration and Querying.
                    </a></div>
                    <div className = "left-tight">Jun 28, 2017</div>
                    <div className = "right-tight">Ph.D. Defense, Georgia Tech, Atlanta, GA, USA</div>
                    <div className = "left-tight">Apr 6, 2016</div>
                    <div className = "right-tight">Ph.D. Proposal, Georgia Tech, Atlanta, GA, USA</div>

                    <div className = "right-tight bold space-above">VISAGE: Visual Graph Query Construction and Refinement</div>
                    <div className = "left-tight">May 18, 2017</div>
                    <div className = "right-tight">IEEE SIGMOD Best-of Demonstration Session, Chicago, IL, USA</div>
                    <div className = "left-tight">May 15, 2017</div>
                    <div className = "right-tight">IEEE SIGMOD Demonstration, Chicago, IL, USA</div>
                    <div className = "left-tight">Nov 8, 2016</div>
                    <div className = "right-tight">Georgia Tech Hot CSE Presentation, Atlanta, GA, USA</div>
                    <div className = "left-tight">Jun 10, 2016</div>
                    <div className = "right-tight">ACM AVI Paper Talk, Bari, Italy</div>
                    <div className = "left-tight">Mar 30, 2016</div>
                    <div className = "right-tight">ACM IUI Poster Presentation and Fast Forward, Atlanta, GA, USA</div>

                    <div className = "right-tight bold space-above">VIGOR: Visualizing, Summarizing, and Comparing Graph Query Results</div>
                    <div className = "left-tight">Oct 2, 2017</div>
                    <div className = "right-tight">(to appear) IEEE VAST Paper Presentation, Phoenix, AZ, USA</div>
                    <div className = "left-tight">Oct 26, 2016</div>
                    <div className = "right-tight">IEEE VIS Poster Presentation and Fast Forward, Baltimore, MD, USA</div>

                    <div className = "right-tight bold space-above">FACETS: Adaptive Local Exploration of Large Graphs</div>
                    <div className = "left-tight">Apr 28, 2017</div>
                    <div className = "right-tight">SIAM SDM Paper Talk, Houston, TX, USA</div>
                    <div className = "left-tight">Apr 17, 2017</div>
                    <div className = "right-tight">Presentation at Machine Learning at Georgia Tech (ML@GT), Atlanta, GA, USA</div>
                    <div className = "left-tight">Oct 26, 2015</div>
                    <div className = "right-tight">IEEE VIS Poster Presentation and Fast Forward, Chicago, IL, USA </div>


                    <div className = "right-tight bold space-above">Pindrop Culminating Research Presentation</div>
                    <div className = "left-tight">Aug 12, 2016</div>
                    <div className = "right-tight">Presentation to Management and Research at Pindrop, Atlanta, GA, USA</div>
                    <div className = "left-tight">Aug 9, 2015</div>
                    <div className = "right-tight">Presentation to Research and Engineering at Pindrop, Atlanta, GA, USA</div>

                    <div className = "right-tight bold space-above">Google Intern Final Presentation</div>
                    <div className = "left-tight">Aug 12, 2016</div>
                    <div className = "right-tight">Presentation to managers to launch my code at Google! Mountain View, CA, USA</div>
                    <div className = "left-tight">Aug 9, 2015</div>
                    <div className = "right-tight">Presentation of completed projects at Google, Mountain View, CA, USA</div>

                    <div className = "right-tight bold space-above">FLAMEL (NSF Fellowship)</div>
                    <div className = "left-tight">Apr 25, 2017</div>
                    <div className = "right-tight">Presentation to Board of Directors, Atlanta, GA, USA</div>

                    <div className = "left-tight">Nov 19, 2016</div>
                    <div className = "right-tight"><em>Human in the loop material science image segmentation</em>, Atlanta, GA, USA</div>
                    <div className = "left-tight">Aug 9, 2016</div>
                    <div className = "right-tight">Invited Panelist, Atlanta, GA, USA</div>
                    <div className = "left-tight">Mar 12, 2016</div>
                    <div className = "right-tight">Computational Material Science Chalk Talk, Atlanta, GA, USA</div>

                    <div className = "left-tight">Jan 12, 2015</div>
                    <div className = "right-tight">Invited Panelist, Atlanta, GA, USA</div>

                    <div className = "right-tight bold space-above">MAGE: Approximate Graph Querying</div>
                    <div className = "left-tight">Mar 28, 2015</div>
                    <div className = "right-tight">Georgia Tech Hot CSE Presentation, Atlanta, DC, USA</div>
                    <div className = "left-tight">Oct 28, 2014</div>
                    <div className = "right-tight">IEEE Bigdata Paper Talk, Washington, DC, USA</div>


                    <div className = "right-tight bold space-above">STEPS: Spatio-temporal Electrical Network Visualization</div>
                    <div className = "left-tight">Mar 8, 2016</div>
                    <div className = "right-tight">ACM IUI Short Paper Talk, Sonoma, CA, USA</div>

                    <div className = "right-tight bold space-above">Fraud in the telephony channel</div>
                    <div className = "left-tight">Dec 19, 2016</div>
                    <div className = "right-tight">IEEE ICMLA Paper Talk, Irvine, CA, USA</div>

                    <div className = "right-tight bold space-above">Nerd Nite: Nerdy Talks for Everyone</div>
                    <div className = "left-tight">Sep 9, 2016</div>
                    <div className = "right-tight"><em>Is Dwarf Fortress Art?</em>, Atlanta, GA, USA</div>
                    <div className = "left-tight">Aug 22, 2016</div>
                    <div className = "right-tight"><em>Findings from Mining Craigslist Missed Connections</em>, Atlanta, GA, USA</div>

                    <div className = "right-tight bold space-above">InvestorRank: Identifying Successful Investors in the Startup Ecosystem</div>
                    <div className = "left-tight">May 19, 2015</div>
                    <div className = "right-tight">IEEE WWW Short Paper Talk, Florence, Italy</div>


                    <h3> Teaching </h3>
                    <div className = "left"> Spring 2016</div>
                    <div className = "right">
                      <span className = 'bold'> Volunteer Instructor</span>
                      <span className = "space"/>
                      <em> Georgia Tech, Atlanta, GA </em>
                      <br/>
                      <div> As part of the FLAMEL program, taught how the use the python programming language for material science automation, modeling, and analysis. </div>
                    </div>

                    <div className = "left"> Spring 2015</div>
                    <div className = "right">
                      <span className = 'bold'>Guest Lecturer </span>
                      <span className = "space"/>
                      <em>Georgia Tech, Atlanta, GA </em>
                      <br/>
                      Guest lectured in the Data and Visual Analytics course (CSE 6242) for Polo Chau.
                      <span className = "dark-orange"> Over 180 students!</span>
                    </div>

                    <div className = "left"> Spring 2014 </div>
      							<div className = "right">
                      <span className = 'bold'>Graduate Teaching Assistant </span>
                      <span className = "space"/>
                      <em>Georgia Tech, Atlanta, GA </em>
                      <br/>
                      Assisted in teaching and administering the graduate Data and Visual Analytics
                      (CSE 6242).
                      <span className = "dark-orange"> Over 100 students!</span>
                    </div>

      							<div className = "left"> Spring 2012 </div>
      							<div className = "right">
                      <span className = 'bold'>Graduate Teaching Assistant </span>
                      <span className = "space"/>
                      <em>Georgia Tech, Atlanta, GA </em>
                      <br/>
                      Assisted in teaching and administering Advanced Modeling and Simulation: Fundamentals & Implementation (CSE6730).
                    </div>

                    <span className="space"/>
                    <div className = "right-tight bold"> Mentor</div>
                    <div className = "left-tight">2015-2017</div>
                    <div className = "right-tight"> Dezhi Fang, Undergraduate, CSE </div>
                    <div className = "left-tight">2015</div>
                    <div className = "right-tight"> Srishti Gupta, Master's Student, CSE </div>
                    <div className = "left-tight">2013-2014</div>
                    <div className = "right-tight"> Zhiyuan Lin, Undergraduate, CS </div>
                    <div className = "left-tight">2013</div>
                    <div className = "right-tight"> Yiqi Chen, Undergraduate, CS </div>
                    <h3> Technical Skills </h3>
                    <div className = "left"> Programming </div>
      							<div className = "right"> Python &nbsp; C/C++ &nbsp; Javascript  &nbsp; Matlab &nbsp; Java &nbsp; R  &nbsp; SQL &nbsp; Cypher </div>
      							<div className = "left"> HPC </div>
      							<div className = "right"> MPI &nbsp; OpenMP &nbsp; MapReduce</div>
      							<div className = "left"> Visualization </div>
      							<div className = "right"> D3 &nbsp; React &nbsp;  WebGL &nbsp; OpenGl &nbsp; jQuery</div>




                    <h3> Professional & Academic Service </h3>
                    <div className = "left-half bold"> Reviewer or Program Committee Member</div>
                    <div className = "left-tight">2015-2016</div>
                    <div className = "right-tight"> KDD </div>
                    <div className = "left-tight">2016</div>
                    <div className = "right-tight"> WWW </div>
                    <div className = "left-tight">2017</div>
                    <div className = "right-tight"> SDM </div>
                    <div className = "left-tight">2014-2016</div>
                    <div className = "right-tight"> CHI </div>
                    <div className = "left-tight">2014-2016</div>
                    <div className = "right-tight"> IUI </div>
                    <div className = "left-tight">2017</div>
                    <div className = "right-tight"> TIST Journal </div>
                    <div className = "left-tight">2017</div>
                    <div className = "right-tight"> BigData </div>
                    <div className = "left-tight">2016-2017</div>
                    <div className = "right-tight"> IDEA Workshop </div>
                    <span className="space"/>

                    <div className = "left-half bold">Society Member</div>
                    <div className = "left-tight">2016-2017</div>
                    <div className = "right-tight">Society for Applied Mathematics (<em>SIAM</em>)</div>
                    <div className = "left-tight">2014-2017</div>
                    <div className = "right-tight">Association for Computing Machinery (<em>ACM</em>)</div>
                    <div className = "left-tight">2012-2017</div>
                    <div className = "right-tight">Institute of Electrical and Electronics Engineers (<em>IEEE</em>)</div>
                    <div className = "left-tight">2009-2011</div>
                    <div className = "right-tight">Member of Pi Mu Epsilon</div>
                    <div className = "left-tight">2008-2011</div>
                    <div className = "right-tight">Member of Upsilon Pi Epsilon</div>
                    <div className = "left-tight">2009-2011</div>
                    <div className = "right-tight">Vice President of Upsilon Pi Epsilon</div>
      					</div>
                  <img className = "easteregg" ref={this} onClick={this.handleClick} src="imgs/easteregg/egglet.png"/>
      				</div>
      			</div>
      		</div>
      	</div>
      </div>
    );
  }

};



// WEBPACK FOOTER //
// ./src/pages/index.js